module.exports = __webpack_public_path__ + "img/wallet.3b5f632c.svg";